module.exports = __webpack_public_path__ + "static/media/vail-6.36d619e1.jpg";